import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/styles/icons.css";
import "./assets/styles/global.css";
import "./assets/styles/animation.css";
import "./assets/styles/tag-input-styles.css";
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {Provider} from "react-redux";
import {store} from "./redux/store/store";
import { GoogleOAuthProvider } from '@react-oauth/google';
import {Splash} from "./components";

const root = ReactDOM.createRoot(document.getElementById('root'));

const Loading = () => (
    <Splash />
)

root.render(
    <>
        <ToastContainer hideProgressBar autoClose={5000} limit={3} theme='colored'/>
        <BrowserRouter>
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                <Provider store={store}>
                    <Suspense fallback={<Loading/>}>
                        <App />
                    </Suspense>
                </Provider>
            </GoogleOAuthProvider>
        </BrowserRouter>
    </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
